import {get, isEmpty} from 'lodash'
import {http} from '@/axios'
import checkAuthForRoute from '../helpers/checkAuthForRoute'
import {PARTNER, EMPLOYEE, EMPLOYER, MODERATOR, AGENT} from '@/constants/usersTypes'
import userPusher from './userPusher'
import userNotifications from './userNotifications'
import $router from "@/router"

function getInitState() {
  return {
    loaded: false,
    pending: false,
    token: null,
    profile: null,
    //for header l
    notifications: [],
    chatMessages: [],
    chatBotUrls: [],
    chatBotUrlsPrimary: [],
    chatBotUrlsJobianPay: [],
    moderatedPassport: false,
    notificationsCount: 2,
    messagesCount: 3,
    bookmarksCount: 0,
    cookieMsg: '',
    receivedResumesCount: 0,
    receivedNewResumesCount: 0,
    recommendedVacanciesCount: 0,
    approvedResumesCount: 0,
    openedInteractionId: null,
    isResumeMainSectionsSaved: false,
    employerChecklist: null,
    resumeCompleted: null,
    showPrimaryPopup: false,
    resume: null,
    isOur: false,
    hasResponses: false,
    employerProfile: defaultEmployerProfile(),
    moderatorVerifyProfile: false,

    tidioAppScript: null,
    replainChatScript: null,
  }
}

function defaultEmployerProfile() {
  return { profile_status: 'not_save' };
}

const user = {
  namespaced: true,
  modules: {
    userPusher,
    userNotifications,
  },
  state: getInitState(),
  getters: {
    isLogged(state) {
      return !!state.token
    },
    userType(state) {
      return get(state, 'profile.user_type')
    },
    isEmployer(undefined, getters) {
      return getters['userType'] === EMPLOYER
    },
    isEmployee(undefined, getters) {
      return getters['userType'] === EMPLOYEE
    },
    isPartner(undefined, getters) {
      return getters['userType'] === PARTNER
    },
    isAgent(undefined, getters) {
      return getters['userType'] === AGENT
    },
    isModerator(undefined, getters) {
      return getters['userType'] === MODERATOR
    },
    isOur(state) {
      return state.isOur;
    },
    isOurEmployer(state, getters) {
      return getters['userType'] === EMPLOYER && state.isOur;
    },
    receivedResumesCount(state) {
      return state.receivedResumesCount || 0
    },
    receivedNewResumesCount(state) {
      return state.receivedNewResumesCount || 0
    },
    recommendedVacanciesCount(state) {
      return state.recommendedVacanciesCount || 0
    },
    approvedResumesCount(state) {
      return state.approvedResumesCount || 0
    },
    hasInteraction(state) {
      return !!state.openedInteractionId
    },
    canRespondOnVacancy(state) {
      const profile = state.profile
      return !profile ||
        (profile.user_type === EMPLOYEE)
    },
    bookmarksCount(state, getters) {
      if (
        getters.isLogged
        && getters.userType !== EMPLOYEE
        && !getters.hasInteraction
      ) return null

      return state.bookmarksCount || null
    },
    hasVacanciesResponses(state) {
      return state.hasResponses;
    },
    employerProfile(state) {
      return state.employerProfile;
    },
    moderatorVerifiedProfile(state) {
      return state.moderatorVerifyProfile;
    },
  },
  mutations: {
    //RESET
    resetState(state) {
      Object.assign(state, getInitState())
    },
    pending(store, value = true) {
      store.pending = value
    },
    saveToken(store, token) {
      store.token = token
    },
    saveMessage(store, msg) {
      store.cookieMsg = msg
    },
    saveUser(store, user) {
      store.profile = user
    },
    logout(store) {
      store.loaded = false
      store.token = null
      store.profile = null
      store.notifications = null
      store.chatMessages = null
      store.notificationsCount = null
      store.messagesCount = null
      store.receivedResumesCount = null
      store.receivedNewResumesCount = null
      store.recommendedVacanciesCount = null
      store.approvedResumesCount = null
      store.openedInteractionId = null
      store.isResumeMainSectionsSaved = null
      store.showPrimaryPopup = false
      store.resume = null
      store.employerProfile = defaultEmployerProfile()
    },
    setUserType(store, type) {
      store.userType = type
    },
    setRecommendedVacancies(state, vacancies) {
      state.recommendedVacancies = vacancies
    },
    setReceivedResumes(state, resumes) {
      state.receivedResumes = resumes
    },
    saveNotifications(state, value) {
      state.notifications = value
    },
    saveChatMessages(state, value) {
      state.chatMessages = value
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      state[key] = value
    },
    setBalance(state, balance) {
      state.profile.balance = balance
    },
    updateEmployerProfile(state, data) {
      if (!state.employerProfile) state.employerProfile = defaultEmployerProfile();
      Object.assign(state.employerProfile, data);
    },
  },
  actions: {
    async init({commit, dispatch}) {
      let token = getTokenFromLocalStorage()
      let user = getUserFromLocalStorage()

      if (user) {
        commit('saveUser', user)
      }

      if (token) {
        commit('saveToken', token)
      } else {
        commit('logout')
        removeTokenFromLocalStorage()
        removeUserFromLocalStorage()
      }


      if (token) {
        await dispatch('loadUser')
      } else {
        await dispatch('loadUnauthorizedUser')
      }
    },
    loadUnauthorizedUser({dispatch}) {
      return Promise.all([
        dispatch('loadUnauthorizedBookmarksCount')
      ])
    },
    loadUnauthorizedBookmarksCount({commit}) {
      return http.get('/api/new-vacancy/bookmarks-count').then(({data}) => {
        commit('setProperty', ['bookmarksCount', data.data || 0])
      })
    },
    loadUser({state, commit, dispatch}) {
      if (!state.token) {
        return Promise.resolve('no logged user')
      }

      return http.get('/api/cabinet/user').then(({data}) => {
        commit('saveUser', data.user)
        addUserToLocalStorage(data.user)

        commit('setProperty', ['loaded', true])
        commit('setProperty', ['receivedResumesCount', data['vacancies-with-resume-count']])
        commit('setProperty', ['receivedNewResumesCount', data['new-resume-count']])
        commit('setProperty', ['recommendedVacanciesCount', data['recommended-vacancies-count']])
        commit('setProperty', ['approvedResumesCount', data['approved-resumes']])
        commit('setProperty', ['openedInteractionId', data['opened_interaction_id']])
        commit('setProperty', ['bookmarksCount', data['bookmarks_count']])
        commit('setProperty', ['chatBotUrls', data['urls']])
        commit('setProperty', ['chatBotUrlsPrimary', data['urls_primary']])
        commit('setProperty', ['chatBotUrlsJobianPay', data['urls_jobianpay']])
        commit('setProperty', ['moderatedPassport', data['moderated_passport']])
        commit('setProperty', ['resumeCompleted', data['resumeCompleted']])
        commit('setProperty', ['employerChecklist', data['employer_checklist']])
        commit('setProperty', ['hasResponses', data['has_responses']])
        commit('saveNotifications', data.notifications)
        commit('saveChatMessages', data.messages)
        commit('userNotifications/setProperty', ['newNotificationCount', data.new_notify_count || 0])
        commit('setProperty', ['showPrimaryPopup', !data.primary_popup])
        commit('setProperty', ['isOur', data.is_our])
        commit('setProperty', ['moderatorVerifyProfile', data.employer_checklist.moderator_verify_profile])

        commit('updateEmployerProfile', data.employer_profile)

        if (data.resume && !isEmpty(data.resume.parsed_questionaire_data)) {
          commit('setProperty', ['resume', data.resume])
          commit('setProperty', ['isResumeMainSectionsSaved', true])
        }

        dispatch('afterLogin')

        return data
      }).catch(e => {
        removeTokenFromLocalStorage()
        removeUserFromLocalStorage()
        commit('logout')
        dispatch('loadUnauthorizedUser')
        dispatch('removeIntegratedChats')
        throw e
      })
    },
    registerUser({commit, dispatch}, {sendData, remember}) {
      commit('logout')

      return http.post('/api/auth/register', sendData).then(async ({data}) => {
        return dispatch('afterAuth', {data, remember})
      })
    },
    loginUser({commit, dispatch}, {sendData, remember}) {
      commit('logout')

      return http.post('/api/auth/login', sendData).then(async ({data}) => {
        return dispatch('afterAuth', {data, remember})
      })
    },
    afterAuth({commit, dispatch}, {data, remember}) {
      removeTokenFromLocalStorage()
      removeUserFromLocalStorage()
      addTokenToLocalStorage(data.data.token, !remember)
      if(data.data && data.data.id) {
        addUserToLocalStorage(data.data, !remember)
      }

      commit('saveToken', data.data.token)

      if (data.data.gdpr_show) {
        commit('saveMessage', data.data.gdpr)
      }

      return dispatch('loadUser')
    },
    loginUserByToken({commit}, token) {
      //deprecated
      removeTokenFromLocalStorage()
      addTokenToLocalStorage(token)
      commit('saveToken', token)

      // this.$router.push({name: 'account-profile'})
    },
    forgotPassword(store, sendData) {
      return http.post('/api/auth/forgotten-password', sendData).then(async ({data}) => {
        return data
      })
    },
    forgotPasswordAgent(store, login) {
      return http.post('/api/auth/agent/password-reset', login).then(async ({data}) => {
        return data
      })
    },
    newPassword(store, sendData) {
      return http.patch('/api/auth/forgotten-password', sendData).then(async ({data}) => {
        return data
      })
    },
    logoutUser({commit, dispatch}, { userType }) {
      dispatch('userPusher/unbindAll')

      return http.delete('/api/auth/logout').then(({data}) => {
        this._vm.$intercom && this._vm.$intercom.update && this._vm.$intercom.update()
        return data
      }).finally(() => {
        removeTokenFromLocalStorage()
        removeUserFromLocalStorage()
        commit('logout')
        dispatch('afterLogout')
        dispatch('checkRouteAfterLogout', { userType })
        dispatch('loadUnauthorizedUser')
      })
    },
    getLoginConfirmationCode(store, {sendData, recaptchaToken}) {
      sendData['g-recaptcha-response'] = recaptchaToken

      return http.post('/api/auth/send-code', sendData)
    },
    loginByPhoneAndCode({commit, dispatch}, {sendData, isPartner, recaptchaToken}) {
      commit('logout')

      sendData['g-recaptcha-response'] = recaptchaToken
      const url = isPartner ? '/api/auth/agent-register' : '/api/auth/gate'

      return http.post(url, sendData).then(async ({data}) => {
        removeTokenFromLocalStorage()
        removeUserFromLocalStorage()
        addTokenToLocalStorage(data.data.token)
        addUserToLocalStorage(data.data)
        commit('saveToken', data.data.token)
        if (data.data.gdpr_show) {
          commit('saveMessage', data.data.gdpr)
        }

        dispatch('loadUser')

        return data
      })
    },
    loginByToken({commit, dispatch}, {token}) {
      commit('logout')

      removeTokenFromLocalStorage()
      removeUserFromLocalStorage()
      addTokenToLocalStorage(token)
      commit('saveToken', token)

      return dispatch('loadUser')
    },
    loginEmployer({dispatch}, payload) {
      payload.remember = true // add to local storage
      return dispatch('loginUser', payload)
    },
    registerEmployer({dispatch}, payload) {
      payload.remember = true // add to local storage
      return dispatch('registerUser', payload)
    },
    resetPasswordAgent(context, data) {
      return http.post('/api/auth/agent/password-change', data)
    },
    loginAgent({commit, dispatch}, {sendData}) {
      commit('logout')

      return http.post('/api/auth/agent/login', sendData)
          .then(({data}) => {
            return dispatch('afterAuth', {data, remember: true})  // remember: true - add to local storage
          })
    },
    // chooseUserType({commit}, type){
    //   commit('setUserType', type)
    // },
    // loadRecommendedVacanciesList({commit}) {
    //   return http.get('/api/cabinet/recommended-vacancies').then(({data})=>{
    //     commit('setRecommendedVacancies', data.data)
    //   })
    // },
    // loadReceivedResumesList({commit}) {
    //   return http.get('/api/cabinet/vacancies-with-resume').then(({data})=>{
    //     commit('setReceivedResumes', data.data.data)
    //   })
    // },
    // getNotifications({commit}){
    //   return http.get('/api/notifies').then(({data})=>{
    //     commit('saveNotifications', data.data)
    //   })
    // },
    // getChatMessages({commit}){
    //   return http.get('/api/messages').then(({data})=>{
    //     commit('saveChatMessages', data.data)
    //   })
    // }
    afterLogin({state, dispatch}) {
      if (state.profile.user_type === PARTNER) {
        dispatch('subscriberOnBalance')
      }

      if (state.profile.user_type === EMPLOYER) {
        dispatch('subscriberOnReceivedResumes')
      }

      if (state.profile.user_type === EMPLOYEE) {
        dispatch('subscriberOnResumeChange')
      }

      if (state.profile.user_type === AGENT) {
        dispatch('subscriberOnBalance')
      }

      dispatch('integrateThirdPartyChats');
      dispatch('subscribeOnEmployerProfileUpdate')
      dispatch('subscriberOnInteractionStartEnd')
      dispatch('userNotifications/subscriberOnNotification')
    },
    afterLogout({dispatch}) {
      dispatch('unSubscribeOnBalance')
      dispatch('unSubscribeOnReceivedResumes')
      dispatch('unSubscribeOnInteractionStartEnd')
      dispatch('unSubscribeOnResumeChange')
      dispatch('unsubscribeOnEmployerProfileUpdate')
      dispatch('userNotifications/unSubscribeOnNotification')
      dispatch('removeIntegratedChats')
    },
    checkRouteAfterLogout(_, { userType }) {
      if (!checkAuthForRoute($router.currentRoute)) return

      const requiredUserTypeRoute = $router.currentRoute.matched.reverse().find(record => {
        return Array.isArray(record.meta.requiredUserTypes) && record.meta.requiredUserTypes.length
      })

      const requiredUserTypes = requiredUserTypeRoute.meta.requiredUserTypes

      if (
        requiredUserTypes
        && requiredUserTypes.length === 1
        && requiredUserTypes[0] === MODERATOR
      ) {
        return $router.push({
          name: 'sign-in-moderator',
          query: {
            redirect: $router.currentRoute.fullPath,
          }
        })
      }

      const routeName = getLogoutRouteName(userType);

      $router.push({
        name: routeName,
        query: {
          redirect: $router.currentRoute.fullPath,
        }
      })
    },
    subscriberOnBalance({commit, rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnBalance')

      const channel = rootState.user.userPusher.channel
      channel.bind('balance-notify', ({balance_data}) => {
        commit('setBalance', balance_data.balance)
      })
    },
    unSubscribeOnBalance({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('balance-notify')
    },
    subscriberOnReceivedResumes({rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnReceivedResumes')

      const channel = rootState.user.userPusher.channel
      channel.bind('resume-count-notify', (data) => {
        dispatch('updateResumesCount', data);
      });
    },
    updateResumesCount({ commit }, { count, new_count }) {
      commit('setProperty', ['receivedResumesCount', count])
      commit('setProperty', ['receivedNewResumesCount', new_count])
    },
    unSubscribeOnReceivedResumes({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('resume-count-notify')
    },
    subscriberOnInteractionStartEnd({rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnInteractionStartEnd')

      const channel = rootState.user.userPusher.channel
      channel.bind('interaction-start-end', () => {
        dispatch('loadUser')
      })
    },
    unSubscribeOnInteractionStartEnd({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('interaction-start-end')
    },
    subscriberOnResumeChange({rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnResumeChange')

      const channel = rootState.user.userPusher.channel
      channel.bind('update-resume-link', () => {
        dispatch('loadUser')
      })
    },
    unSubscribeOnResumeChange({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-resume-link')
    },
    subscribeOnEmployerProfileUpdate({ rootState, dispatch }) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unsubscribeOnEmployerProfileUpdate')

      const channel = rootState.user.userPusher.channel
      channel.bind('update-employer-profile', () => {
        dispatch('loadUser')
      });
    },
    unsubscribeOnEmployerProfileUpdate({ rootState }) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-employer-profile');
    },
    updateEmployerProfile({ commit }, payload) {
      commit('updateEmployerProfile', payload);
    },
    integrateThirdPartyChats({ dispatch }) {
      dispatch('integrateTidioApp');
    },
    removeIntegratedChats({ dispatch }) {
      dispatch('removeTidioApp');
    },
    integrateReplainChat({ state, dispatch }) {
      try {
        if (state.replainChatScript) {
          dispatch('removeReplainChat');
        }

        if (state.tidioAppScript) {
          dispatch('removeTidioApp');
        }

        window.replainSettings = { id: '73105946-3b56-407d-bb25-c51b9d286eb0' };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://widget.replain.cc/dist/client.js';
        const x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(script, x);

        state.replainChatScript = script;
      } catch (e) {
        console.error('There are some problems with Replain chat integration');
        console.error(e);
      }
    },
    removeReplainChat({ state }) {
      try {
        if (!state.replainChatScript) return;

        state.replainChatScript.remove();
        document.getElementById('__replain_widget')?.remove();
        delete window.replainInitialized;
        state.replainChatScript = null;
      } catch (e) {
        console.error('There are some problems when removing Replain chat');
        console.error(e);
      }
    },
    integrateTidioApp({ rootState, getters, state, dispatch }) {
      if (!getters.isLogged || getters.userType === EMPLOYEE) return;

      try {
        if (![EMPLOYER, AGENT, PARTNER].includes(state.profile?.user_type) || state.tidioAppScript) {
          dispatch('removeTidioApp');
        }

        document.tidioChatLang = rootState.currentLocale;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://code.tidio.co/er2rqye1vjn7s3mi6ikoygnxb49caqfb.js';
        document.body.appendChild(script);

        state.tidioAppScript = script;
      } catch (e) {
        console.error('There are some problems with Tidio chat integration');
        console.error(e);
      }
    },
    removeTidioApp({ state }) {
      try {
        if (!state.tidioAppScript) return;

        window.tidioChatApi?.close();
        state.tidioAppScript.remove();
        document.getElementById('tidio-chat')?.remove();
        document.getElementById('tidio-chat-code')?.remove();
        state.tidioAppScript = null;
      } catch (e) {
        console.error('There are some problems when removing Tidio chat');
        console.error(e);
      }
    },
  }
}

function getLogoutRouteName(userType) {
  switch (userType) {
    case EMPLOYEE: return 'auth';
    case PARTNER: return 'auth';
    case EMPLOYER: return 'auth-employer-double';
    case AGENT: return 'auth-agent-double';
    case MODERATOR: return 'sign-in-double';
    default: return 'auth';
  }
}

function addTokenToLocalStorage(token, isSessionOnly) {
  if (!token) return
  if (isSessionOnly) {
    return sessionStorage.setItem('token', token)
  }

  return localStorage.setItem('token', token)
}

function removeTokenFromLocalStorage() {
  sessionStorage.removeItem('token')
  localStorage.removeItem('token')
}

function getTokenFromLocalStorage() {
  return sessionStorage.getItem('token') || localStorage.getItem('token') || null
}

// - - - -

function addUserToLocalStorage(user, isSessionOnly) {
  if (!user) return
  if (isSessionOnly) {
    return sessionStorage.setItem('user', JSON.stringify(user))
  }

  return localStorage.setItem('user', JSON.stringify(user))
}

function removeUserFromLocalStorage() {
  sessionStorage.removeItem('user')
  localStorage.removeItem('user')
}

function getUserFromLocalStorage() {
  const user = sessionStorage.getItem('user') || localStorage.getItem('user') || null
  return user ? JSON.parse(user) : null
}


export default user
